<span class="c-user-search-field">
  <label
    class="form-label"
    for="userSearchField__searchTerm"
    i18n="@@userSearchField-label-searchForUser"
    >Search for user</label
  >
  <input
    matInput
    [formControl]="userCtrl"
    id="userSearchField__searchTerm"
    [matAutocomplete]="userResults"
    class="form-control input-bootstrap-material"
  />

  <mat-autocomplete
    #userResults="matAutocomplete"
    [autoActiveFirstOption]="true"
    (optionSelected)="selectUser($event)"
    class="c-user-search-field__results"
  >
    <ng-container *ngIf="searchState.isLoading === false">
      <mat-option
        *ngIf="searchState.error"
        [disabled]="true"
        class="c-user-search-field__results__unselectable qa-search-error"
        role="alert"
        i18n="@@userSearchField-autocomplete-option-searchError"
      >
        Sorry, we had problems running your search. Please try again.
      </mat-option>

      <mat-option
        *ngIf="searchState.searchResults?.total === 0"
        [disabled]="true"
        class="c-user-search-field__results__unselectable qa-no-results"
        role="status"
        i18n="@@userSearchField-autocomplete-option-noResults"
      >
        Sorry there were no results for "{{ userCtrl.value }}". Try to be less
        specific.
      </mat-option>

      <mat-option
        *ngIf="searchState.searchResults?.total > MAX_USERS_LIMIT"
        [disabled]="true"
        class="c-user-search-field__results__unselectable qa-too-many-results"
        role="status"
        i18n="@@userSearchField-autocomplete-option-tooManyResults"
      >
        There were lots of results for "{{ userCtrl.value }}". Try to be more
        specific.
      </mat-option>

      <mat-option
        *ngFor="
          let user of searchState.searchResults?.users
            | slice : 0 : MAX_USERS_LIMIT
        "
        [value]="user"
        class="tt-suggestion c-user-search-field__results__result"
      >
        {{ user.full_name }}
        <span
          class="c-user-search-field__results__result__role"
          i18n="@@userSearchField-autocomplete-option-label-userJobRole"
          >{user.job_role_description, select, academic {an academic} teacher {a
          teacher} lecturer {a lecturer} educational_support {educational
          support} undergraduate {an undergraduate} postgraduate {a
          postgraduate} researcher {a researcher} librarian {a librarian}
          learning_technologist {a learning technologist} non_teaching_faculty
          {non-teaching faculty}}</span
        >
      </mat-option>

      <mat-divider *ngIf="searchState.searchResults"></mat-divider>
    </ng-container>
    <mat-option
      [value]="currentUser.tarlUser"
      class="tt-suggestion qa-assign-to-me"
      i18n="@@userSearchField-autocomplete-option-assignToMe"
    >
      Assign to me
    </mat-option>
  </mat-autocomplete>
</span>
